import config from './../config';


export default {

  loadPapeletas({commit},payload){

    console.log('Estamos consultando las papeletas con el usuario ',payload);
    axioss.get(config.serverURI + 'aplicaciones/listpapeleta/'+payload)
      .then((data)=>{
        console.log('Finalizando',data);



        console.log('despeus de swal');
        commit('loadPapeletas',data.data);


      })
    console.log('Al menos llego al action');



  },


  loadTipoPapeletas({commit}){

    axioss.get(config.serverURI + 'aplicaciones/tipospapeleta')
      .then((response) => {
        console.log('Devuelve la lista papaleta', response);
        let data = response.data;

        commit('loadTipoPapeletas',data);

      })
  },

  selectPapeleta({commit},papeleta){
    commit('selectPapeleta',papeleta)
  },


  editarPapleta({commit}, papeleta){

    commit('editarPapleta',papeleta)
  },

  selectMarcacion({commit},marcacion){
    commit('selectMarcacion',marcacion);
  },

  log_user({commit}){
    console.log('CONSULTAMOS USER');

    axioss.get(config.serverURI + 'aplicaiones/user_log')
      .then((response)=>{
        console.log('EL RESUTLADO LLEGA del log user',response);

        //simulamos que devolvio el de percy PBARRIENTOS
        commit('setUserCAS','PBARRIENTOS')
      })
  }

}



// WEBPACK FOOTER //
// ./src/store/actions.js